import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
// @ts-ignore
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import {
  IconButton,
} from '@fluentui/react';
// @ts-ignore
import { compareCivilDate } from '@bingads-webui-universal/temporal-utitlities';
import { getNextPreviousDate, getNextPreviousRangeTypeIndex, getRangeString, getComparedDate } from './utils';
import { pickerStyles } from './style';

interface I18n {
  getString(key: any): string;
}


export function QuickDateLeftRightPicker(props: {
  onPickDateRanges: (arg0: { selectedRange: any; rangeId: number; rangeIndex: number; }) => void,
  rangeType: any,
  selectedRange: any,
  selectedComparedRange: any
  rangeIndex: any,
  className?: string,
  shouldShowComparedInInput: boolean,
  minDate: any,
  maxDate: any,
  dateRangeLogger?: (any: any) => void,
  rangeDays?: number,
  comparedRangeDays?: number,
  comparedOption: {
    type: number,
  },
}): JSX.Element {
  const {
    className, onPickDateRanges, rangeIndex, rangeType, selectedRange,
    shouldShowComparedInInput, minDate, maxDate, rangeDays, dateRangeLogger,
    selectedComparedRange, comparedOption, comparedRangeDays,
  } = props;

  const i18n: I18n = useContext(I18nContext);
  const classes: any = useDefaultStyles(() => pickerStyles);
  const { next: nextDate, previous: previousDate } = getNextPreviousDate(rangeType, selectedRange, minDate, maxDate, rangeDays);
  const { next, previous } = getNextPreviousRangeTypeIndex(rangeType, rangeIndex);

  const isPreviousDisabled = previousDate == null || compareCivilDate(previousDate, selectedRange) === 0;
  const isNextDisabled = nextDate == null || compareCivilDate(nextDate, selectedRange) === 0;

  const nextComparedDate = getComparedDate({
    range: nextDate,
    comparedRange: selectedComparedRange,
    comparedOption,
    rangeType: {
      rangeId: next?.rangeId,
    },
    next: true,
    comparedRangeDays,
    comparedOn: shouldShowComparedInInput,
    minDate,
    maxDate,
  });
  const previousComparedDate = getComparedDate({
    range: previousDate,
    comparedRange: selectedComparedRange,
    comparedOption,
    rangeType: {
      rangeId: previous?.rangeId,
    },
    next: false,
    comparedRangeDays,
    comparedOn: shouldShowComparedInInput,
    minDate,
    maxDate,
  });

  useEffect(() => {
    // log the impression on mount
    if (dateRangeLogger) {
      dateRangeLogger({
        method: 'quickImpression',
      });
    }
  }, []);

  return (
    <div className={classNames(
      'quick-date-left-right-picker',
      shouldShowComparedInInput ? classes.high : classes.low,
      shouldShowComparedInInput ? 'high' : 'low',
      classes.picker, className
    )}
    >
      <div className={classNames('icon-buttons')}>
        <IconButton
          iconProps={{ iconName: 'ChevronLeft' }}
          ariaLabel={i18n.getString(_TL_('last date'))}
          onClick={() => {
            const operation = {
              ...previous,
              selectedRange: previousDate,
              selectedComparedRange: previousComparedDate,
            };
            if (dateRangeLogger) {
              dateRangeLogger({
                method: 'quickPrevious',
                ...previous,
                type: getRangeString(previous.rangeId),
              });
            }
            onPickDateRanges(operation);
          }}
          styles={{ root: { fontSize: '12px' }, icon: { fontSize: '12px' } }}
          className={isPreviousDisabled ? classNames('previous-button', 'disabled', classes.disabledColor) : classNames('previous-button', 'active', classes.activeColor)}
          disabled={isPreviousDisabled}
        />
        <IconButton
          iconProps={{ iconName: 'ChevronRight' }}
          ariaLabel={i18n.getString(_TL_('next date'))}
          onClick={() => {
            const operation = {
              ...next,
              selectedRange: nextDate,
              selectedComparedRange: nextComparedDate,
            };
            onPickDateRanges(operation);
            if (dateRangeLogger) {
              dateRangeLogger({
                method: 'quickNext',
                ...next,
                type: getRangeString(next.rangeId),
              });
            }
          }}
          styles={{ root: { fontSize: '12px' }, icon: { fontSize: '12px' } }}
          className={isNextDisabled ? classNames('next-button', 'disabled', classes.disabledColor) : classNames('next-button', 'active', classes.activeColor)}
          disabled={isNextDisabled}
        />
      </div>
    </div>
  );
}

QuickDateLeftRightPicker.defaultProps = {
  className: undefined,
  rangeDays: undefined,
  dateRangeLogger: () => {},
  comparedRangeDays: undefined,
};
